import { CircleAlert } from 'lucide-react';

import type { IconProps } from '@/ux-common/components/icon';
import { Icon } from '@/ux-common/components/icon';

/**
 * The critical icon for an AlertDialog header, paired with a destructive
 * confirm. Sized `icon-lg` / `glyph-lg` because the Figma binds the dialog
 * header's `Icon/lg` chrome to a `size/lg` glyph (see the registry
 * alert-dialog AGENTS.md).
 */
export const CriticalAlertIcon = (props: Omit<IconProps, 'children' | 'className'>) => (
  <Icon {...props} data-component="CriticalAlertIcon" className="icon-lg icon-critical">
    <CircleAlert className="glyph glyph-lg" aria-hidden="true" />
  </Icon>
);
